exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-menu-inline .ant-menu-item.menu-logout,.ant-menu-vertical .ant-menu-item.menu-logout{width:240px}.menu-logout .ant-dropdown-trigger img{margin-right:10px}.ant-menu.collapsed.ant-menu-inline .ant-menu-item{text-overflow:clip}\n", ""]);

// exports
